import React from 'react';

import { useQueryErrorResetBoundary } from '@tanstack/react-query';
import { Button } from 'components/ui/button';
import { CircleAlert } from 'lucide-react';
import { ErrorBoundary } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';
import { NoIndexMeta } from 'shared/ui';

/**
 * for unexpected error,
 * or error handling for useSuspenseQuery
 */
const QueryErrorBoundary = ({ children }: { children: React.ReactNode }) => {
  const { reset } = useQueryErrorResetBoundary();
  const { t } = useTranslation('error');

  return (
    <ErrorBoundary
      onReset={reset}
      fallbackRender={({ resetErrorBoundary }) => (
        <div className="flex h-screen flex-col items-center justify-center">
          {/* 에러 화면이 검색엔진에 색인되지 않도록 (청크 로드 실패 화면이
              "Unexpected Application Error!" 제목으로 구글에 색인된 사례 있음, 2026-07) */}
          <NoIndexMeta />
          <CircleAlert className="h-10 w-10 text-red-500" />

          <p className="my-2 text-xl font-semibold">{t('serverError.title')}</p>

          <p className="text-sm text-gray-500">{t('serverError.description')}</p>

          <Button size="lg" className="mt-4 cursor-pointer bg-primary text-white" onClick={() => resetErrorBoundary()}>
            {t('serverError.tryAgain')}
          </Button>
        </div>
      )}
    >
      {children}
    </ErrorBoundary>
  );
};

export default QueryErrorBoundary;
